import { useModal } from "react-hooks-use-modal";
import React, { Fragment, useEffect, ChangeEvent, useState } from "react";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { useAuth } from "../hooks/use-auth";
import axios from "axios";
import config from "config";
import { Time, removeKeyWithValue } from "utils";
import IdSearchButton from "./IdSearchButton";
import {
  ModalStyle,
  FormLabel,
  FormSelect,
  FormInput,
  FormLabelInputWrapper,
  ModalTitle,
  ModalSubTitle,
  ModalForm,
  ModalSubmitButton,
  LoadingContainer,
  ModalClose,
  SubmitPerformanceButton,
  SubmitPerformanceSpan,
} from "styles/styles";
import { CircularProgress } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useTheme } from "@mui/material/styles";
import jaLocale from "date-fns/locale/ja";

interface ParentDataProps {
  process_name: string;
  charged_user_id: number;
  charged_user_display_id: string;
  charged_user_name: string;
  equipment_name: string;
  working_process_list_id: string;
  working_process_list_display_id: string;
  working_process_list_name: string;
  complete_number: number;
  defective_number: string;
  defective_list_id: string;
  defective_list_display_id: string;
  defective_list_name: string;
  cycle_time: number;
  worked_date: string;
  memo: string;
  check: boolean;
  [key: string]: string | number | boolean;
}

const SubmitPerformances = ({
  selectedData,
  parentClose,
  type,
  setIsParentDataInsert,
}: any) => {
  const [isSubmitDisable, setIsSubmitDisable] = useState<boolean>(false);
  const theme = useTheme();
  //modal
  const [Modal, open, close, isOpen] = useModal("root", {
    preventScroll: true,
  });
  const onSubmit: SubmitHandler<ParentDataProps> = async (
    submitData: ParentDataProps
  ) => {
    let alertList: any[] = [];
    const requiredFields = parentArray
      .filter((obj) => obj.required === true)
      .map((obj) => obj.field);
    requiredFields.forEach((key) => {
      if (submitData[key] === undefined) {
        alertList.push(key);
      }
    });
    if (alertList.length) {
      let text = "";
      parentArray.forEach((item) => {
        if (alertList.includes(item.field)) {
          text += `${item.title}を埋めてください。\n`;
        }
      });
      if (text !== "") {
        alert(text);
        throw new Error("必須項目が未入力です");
      }
    }
    if (parseInt(submitData.defective_number) > 0) {
      if (!submitData.defective_list_id) {
        alert("不良数が1以上の場合は、不良区分を入力してください。");
        throw new Error("必須項目が未入力です");
      }
    }
    submitData = removeKeyWithValue(submitData, "");
    const branchData = {
      charged_user_id: submitData.charged_user_id,
      charged_user_display_id: submitData.charged_user_display_id,
      charged_user_name: submitData.charged_user_name,
      working_process_list_id: submitData.working_process_list_id,
      working_process_list_display_id:
        submitData.working_process_list_display_id,
      working_process_list_name: submitData.working_process_list_name,
      complete_number: submitData.complete_number,
      defective_number: submitData.defective_number,
      defective_list_id: submitData.defective_list_id,
      defective_list_display_id: submitData.defective_list_display_id,
      defective_list_name: submitData.defective_list_name,
      cycle_time: submitData.cycle_time,
      worked_date: submitData.worked_date,
      memo: submitData.memo,
    };
    let answer = true;
    if (parseInt(submitData.working_process_list_id) === 1) {
      answer = window.confirm("工程を完了の作業区分にしますか？");
    }
    if (answer) {
      try {
        setIsSubmitDisable(true);
        await axios.post(
          `/v0/records-processes/${selectedData.records_process_id}/records-performances`,
          branchData,
          {
            headers: auth.authorizationHeader,
            params: { factory_id: auth.factoryId },
          }
        );
        window.alert("登録が完了しました");
        close();
        if (parentClose) {
          parentClose();
        }
        if (setIsParentDataInsert) {
          setIsParentDataInsert(true);
        }
      } catch (error: any) {
        window.alert(error.response.data.error);
      }
      setIsSubmitDisable(false);
    }
  };

  //modal end
  const {
    reset,
    register,
    control,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm<any>();
  const auth = useAuth();

  //arrayの生成
  let parentArray = [
    { title: "工程名", field: "process_name", required: true, disable: true },
    { title: "設備名", field: "equipment_name", required: true, disable: true },
    { title: "", field: "charged_user_id" },
    {
      title: "担当者ID",
      field: "charged_user_display_id",
      disable: true,
      required: true,
    },
    {
      title: "担当者名",
      field: "charged_user_name",
      disable: true,
      required: true,
      search: "users",
    },
    { title: "", field: "working_process_list_id" },
    { title: "", field: "working_process_list_display_id" },
    {
      title: "作業区分",
      field: "working_process_list_name",
      type: "text",
      select: "working_process",
      required: true,
    },
    {
      title: "完了数",
      field: "complete_number",
      default: 0,
      type: "number",
      required: true,
    },
    { title: "不良数", field: "defective_number", default: 0, type: "number" },
    { title: "", field: "defective_list_id" },
    { title: "", field: "defective_list_display_id" },
    {
      title: "不良区分",
      field: "defective_list_name",
      type: "text",
      select: "defective",
    },
    {
      title: "実績加工時間(分)",
      field: "cycle_time",
      type: "number",
      required: true,
    },
    {
      title: "作業した日付",
      field: "worked_date",
      type: "date",
      default: Time.format(new Date(), "YYYY-MM-DD"),
      required: true,
    },
    { title: "メモ", field: "memo", default: "メモ", type: "text" },
  ];

  const defaultObj: any = {};
  for (const element of parentArray) {
    defaultObj[element.field] = element.default;
  }

  interface WorkingOption {
    working_process_list_id: number;
    name: string;
    display_id: string;
  }

  interface DefectiveOption {
    defective_list_id: number;
    name: string;
    display_id: string;
  }

  const [workingOptions, setWorkingOptions] = useState<WorkingOption[]>([]);
  const [defectiveOptions, setDefectiveOptions] = useState<DefectiveOption[]>(
    []
  );

  const handleWorkingSelectChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const selectedOption = event.target.selectedOptions[0];
    setValue("working_process_list_id", selectedOption.dataset.id);
    setValue("working_process_list_display_id", selectedOption.dataset.display);
    setValue("working_process_list_name", selectedOption.dataset.name);
  };

  const handleDefectiveSelectChange = (
    event: ChangeEvent<HTMLSelectElement>
  ) => {
    setSelectedOption(event.target.value);
    const selectedOption = event.target.selectedOptions[0];
    setValue("defective_list_id", selectedOption.dataset.id);
    setValue("defective_list_display_id", selectedOption.dataset.display);
    setValue("defective_list_name", selectedOption.dataset.name);
  };

  useEffect(() => {
    try {
      axios
        .get(`/v0/factories/${auth.factoryId}/working-process-lists`, {
          headers: auth.authorizationHeader,
        })
        .then((res: any) => {
          const completeOption = {
            name: "完了",
            working_process_list_id: 1,
            display_id: "complete",
          };

          if (res.data.length) {
            res.data.unshift(completeOption);
            setWorkingOptions(res.data);
          } else {
            setWorkingOptions([completeOption]);
          }
        });
      axios
        .get(`/v0/factories/${auth.factoryId}/defective-lists`, {
          headers: auth.authorizationHeader,
        })
        .then((res: any) => {
          if (res.data.length) {
            setDefectiveOptions(res.data);
          } else {
            setDefectiveOptions([]);
          }
        });
    } catch (err) {
      console.log(err);
    }
  }, [auth]);

  const [selectedUserContents, setSelectedUserContents] = useState<any>("");

  useEffect(() => {
    setValue("charged_user_id", selectedUserContents.user_id);
    setValue("charged_user_display_id", selectedUserContents.display_id);
    setValue("charged_user_name", selectedUserContents.name);
  }, [selectedUserContents]);

  const defective_number = watch("defective_number");
  useEffect(() => {
    if (parseInt(defective_number) > 0) {
      setHasDefective(true);
    } else {
      setHasDefective(false);
      setValue("defective_list_id", "");
      setValue("defective_list_display_id", "");
      setValue("defective_list_name", "");
      setSelectedOption("");
    }
  }, [defective_number]);

  const [hasDefective, setHasDefective] = useState<boolean>(false);
  const [selectedOption, setSelectedOption] = useState<string>("");

  const listItems = parentArray.map((element: any, index: number) => {
    if (element.title) {
      return (
        <Fragment key={index}>
          <FormLabelInputWrapper>
            <FormLabel htmlFor={element.field}>{element.title}</FormLabel>
            {element.type === "date" ? (
              <Controller
                control={control}
                name={element.field}
                defaultValue={element.default}
                render={({ field: { onChange, value } }) => (
                  <DatePicker
                    label=""
                    value={value ? new Date(value) : null}
                    onChange={(date) => {
                      onChange(date ? Time.format(date, "YYYY-MM-DD") : "");
                    }}
                    PopperProps={{ disablePortal: true }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        required={element.required}
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "40px", // 他の input 要素と高さを揃える
                          },
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#000", // 枠線の色を統一
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: theme.palette.primary.main,
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: theme.palette.primary.main,
                          },
                        }}
                      />
                    )}
                  />
                )}
              />
            ) : element.select === "working_process" ? (
              <FormSelect onChange={handleWorkingSelectChange} required>
                <option hidden value={""}>
                  作業区分を選択してください
                </option>
                {workingOptions.map((item) => (
                  <option
                    key={item.working_process_list_id}
                    data-id={item.working_process_list_id}
                    data-name={item.name}
                    data-display={item.display_id}
                  >
                    {item.name}
                  </option>
                ))}
              </FormSelect>
            ) : element.select === "defective" ? (
              <>
                <FormSelect
                  onChange={handleDefectiveSelectChange}
                  style={{ display: hasDefective ? "block" : "none" }}
                  value={selectedOption}
                >
                  <option hidden value={""}>
                    不良区分を選択してください
                  </option>
                  {defectiveOptions.map((item) => (
                    <option
                      key={item.defective_list_id}
                      value={item.name}
                      data-id={item.defective_list_id}
                      data-name={item.name}
                      data-display={item.display_id}
                    >
                      {item.name}
                    </option>
                  ))}
                </FormSelect>
                <p style={{ display: !hasDefective ? "block" : "none" }}>
                  不良数が1以上で不良区分を選択
                </p>
              </>
            ) : (
              <FormInput
                {...register(element.field)}
                {...(element.type && {
                  type: config.inputErrorMessage[element.type].type,
                })}
                {...(element.type && {
                  placeholder:
                    config.inputErrorMessage[element.type].placeholder,
                })}
                {...(element.type && {
                  pattern: config.inputErrorMessage[element.type].pattern,
                })}
                {...(element.type && {
                  title: config.inputErrorMessage[element.type].title,
                })}
                {...(element.required && { required: true })}
                {...(element.disable && { disabled: true })}
                {...(element.type && {
                  maxLength: config.inputErrorMessage[element.type].maxLength,
                })}
                {...(element.type === "number" && {
                  max: config.inputErrorMessage[element.type].max,
                })}
                {...(element.field.includes("branch") && { max: 99 })}
              />
            )}
            {element.search === "users" ? (
              <IdSearchButton
                search={element.search}
                setSelectedContents={setSelectedUserContents}
              />
            ) : (
              <></>
            )}
          </FormLabelInputWrapper>
        </Fragment>
      );
    }
  });

  const setDefaultData = () => {
    reset(defaultObj);
    setValue("process_name", selectedData.process_name);
    setValue("equipment_name", selectedData.equipment_name);
    setValue("charged_user_id", selectedData.charged_user_id);
    setValue("charged_user_display_id", selectedData.charged_user_display_id);
    setValue("charged_user_name", selectedData.charged_user_name);
    setValue("cycle_time", selectedData.estimated_time);
  };

  const setData = () => {
    setDefaultData();
    open();
  };
  function handleInputClick(event: any) {
    // クリック時の処理をここに追加
    const form = document.querySelector("#performanceForm") as HTMLFormElement;
    form.requestSubmit();
  }

  return (
    <>
      {type === "button" ? (
        <SubmitPerformanceButton onClick={setData}>
          実績入力
        </SubmitPerformanceButton>
      ) : type === "span" ? (
        <SubmitPerformanceSpan onClick={setData}>
          実績入力
        </SubmitPerformanceSpan>
      ) : (
        <></>
      )}
      <Modal>
        <LocalizationProvider dateAdapter={AdapterDateFns} locale={jaLocale}>
          <ModalStyle>
            <ModalTitle>実績入力</ModalTitle>
            <ModalSubTitle>現状の作業区分：{selectedData.status}</ModalSubTitle>
            <ModalForm onSubmit={handleSubmit(onSubmit)} id="performanceForm">
              {listItems}
              {isSubmitDisable ? (
                <LoadingContainer>
                  <CircularProgress size={20} />
                </LoadingContainer>
              ) : (
                <ModalSubmitButton
                  type="button"
                  value="送信する"
                  onClick={handleInputClick}
                  disabled={isSubmitDisable}
                >
                  送信
                </ModalSubmitButton>
              )}
            </ModalForm>
            <ModalClose onClick={close}>CLOSE</ModalClose>
          </ModalStyle>
        </LocalizationProvider>
      </Modal>
    </>
  );
};

export default SubmitPerformances;
